var map = {
	"./legend.png": "OodW",
	"./legend_dark.png": "HQJU",
	"./legend_english.png": "brKA",
	"./legend_english_dark.png": "wWt0",
	"./legend_spanish.png": "vqDR",
	"./legend_spanish_dark.png": "2K20",
	"./legend_xa.png": "TqRZ",
	"./legend_xa_dark.png": "i0OK",
	"./legend_xa_dark_vertical.png": "oxTJ",
	"./legend_xa_english.png": "K1wN",
	"./legend_xa_english_dark.png": "dxDs",
	"./legend_xa_english_dark_vertical.png": "PoPW",
	"./legend_xa_english_vertical.png": "67TI",
	"./legend_xa_spanish.png": "4mpf",
	"./legend_xa_spanish_dark.png": "+Q/V",
	"./legend_xa_spanish_dark_vertical.png": "UJzI",
	"./legend_xa_spanish_vertical.png": "wdY6",
	"./legend_xa_vertical.png": "4Dgi",
	"./legend_xg.png": "9yJL",
	"./legend_xg_dark.png": "zxGK",
	"./legend_xg_dark_vertical.png": "Uen6",
	"./legend_xg_english.png": "Hec4",
	"./legend_xg_english_dark.png": "zRyM",
	"./legend_xg_english_dark_vertical.png": "cKRc",
	"./legend_xg_english_vertical.png": "6yIz",
	"./legend_xg_spanish.png": "CHjW",
	"./legend_xg_spanish_dark.png": "FOr9",
	"./legend_xg_spanish_dark_vertical.png": "gOS5",
	"./legend_xg_spanish_vertical.png": "bTCJ",
	"./legend_xg_vertical.png": "AzRh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fETI";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/legend.*\.png$
// module id = fETI
// module chunks = 94